window.LocationsData = (() => {
    const cacheInterval = 15 * 60 * 1000; // 15 minutes in milliseconds
    const requests = new Map();
    let cachedVersion;

    async function getStores({ apiUrl } = {}) {
        const configuredUrl = window.ncol_locations_json_url?.trim();
        const baseUrl = apiUrl || window.ncol_api_url;
        if (!configuredUrl && !baseUrl) throw new Error('No locations data URL configured.');

        const url = new URL(
            configuredUrl || `${baseUrl.replace(/\/+$/, '')}/public/api/locations.json`,
            window.location.href
        );
        const version = Math.floor(Date.now() / cacheInterval);
        url.searchParams.set('nc', version);

        if (cachedVersion !== version) {
            requests.clear();
            cachedVersion = version;
        }

        const key = url.toString();
        let request = requests.get(key);
        if (!request) {
            request = (async () => {
                const response = await fetch(key, { cache: 'no-cache' });
                if (!response.ok) throw new Error(`Unable to load locations (${response.status}).`);
                const data = await response.json();
                if (data?.status !== 'success' || !Array.isArray(data.stores)) {
                    throw new Error('Invalid locations data response.');
                }
                return data.stores;
            })();
            requests.set(key, request);
        }

        try {
            return structuredClone(await request);
        } catch (error) {
            if (requests.get(key) === request) requests.delete(key);
            throw error;
        }
    }

    return { getStores };
})();
